import DigitalDial from './DigitalDial';
import AdCard from './AdCard';
import { heroLeftAds } from '@/mocks/ads';
import { useAppDownload } from '@/context/AppDownloadContext';
import { useNavigate } from 'react-router-dom';

function DownloadAppButton() {
  const { openModal } = useAppDownload();

  return (
    <div className="hidden lg:block absolute -top-2 left-1/2 -translate-x-1/2 z-20">
      <div className="absolute inset-0 -m-3">
        <div className="absolute inset-0 rounded-full border-2 border-accent-500/60 animate-ripple"></div>
        <div className="absolute inset-0 rounded-full border-2 border-accent-500/50 animate-ripple-delay-1"></div>
        <div className="absolute inset-0 rounded-full border-2 border-accent-500/40 animate-ripple-delay-2"></div>
        <div className="absolute inset-0 rounded-full border-2 border-accent-500/30 animate-ripple-delay-3"></div>
      </div>
      <button
        onClick={openModal}
        className="relative w-[88px] h-[88px] flex flex-col items-center justify-center gap-0.5 rounded-full bg-accent-500 hover:bg-accent-600 text-background-50 font-bold transition-all duration-300 cursor-pointer shadow-xl shadow-accent-500/40 hover:scale-105 hover:shadow-accent-500/60 whitespace-nowrap"
      >
        <i className="ri-download-2-line text-xl"></i>
        <span className="text-[10px] leading-tight text-center">Descargar<br/>App</span>
      </button>
    </div>
  );
}

const communityPills = [
  { label: 'Radio Oficial RFW', icon: 'ri-radio-line', href: '/radio/87-00', color: 'bg-accent-500/90 text-background-50' },
  { label: 'Radios en Vivo', icon: 'ri-live-line', href: '/radios', color: 'bg-red-500/90 text-background-50' },
  { label: 'Programas', icon: 'ri-calendar-check-line', href: '/programas-en-vivo', color: 'bg-emerald-500/90 text-background-50' },
  { label: 'Locutores', icon: 'ri-mic-line', href: '/locutores-en-vivo', color: 'bg-amber-500/90 text-background-50' },
  { label: 'Eventos', icon: 'ri-calendar-event-line', href: '/eventos', color: 'bg-violet-500/90 text-background-50' },
  { label: 'Tendencias', icon: 'ri-fire-line', href: '/tendencias-en-vivo', color: 'bg-rose-500/90 text-background-50' },
  { label: 'Comunidad', icon: 'ri-group-line', href: '/centro-social', color: 'bg-sky-500/90 text-background-50' },
];

const heroStats = [
  { value: 12458, label: 'Radios Activas', icon: 'ri-radio-line', suffix: '+' },
  { value: 3240, label: 'Programas', icon: 'ri-calendar-check-line', suffix: '+' },
  { value: 8500, label: 'Locutores', icon: 'ri-mic-line', suffix: '+' },
  { value: 16500, label: 'Clubes', icon: 'ri-group-line', suffix: '+' },
  { value: 89234, label: 'Oyentes Activos', icon: 'ri-headphone-line', suffix: '+' },
];

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <section id="inicio" className="relative overflow-hidden">
      {/* ── Fondo compartido ── */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20ambient%20community%20gathering%20space%20with%20soft%20golden%20and%20amber%20lighting%2C%20people%20connecting%20through%20music%20and%20conversation%2C%20modern%20social%20platform%20aesthetic%20with%20warm%20rose%20and%20golden%20tones%2C%20abstract%20flowing%20energy%20representing%20community%20connection%2C%20editorial%20photography%20style%20with%20soft%20focus%20and%20warm%20atmospheric%20glow%2C%20no%20text%2C%20organic%20shapes%20and%20flowing%20lines&width=1920&height=1080&seq=hero-social-warm-01&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/55 via-foreground-950/35 to-foreground-950/65"></div>
      </div>

      {/* ═══════════════════════════════════════════════
          MOBILE NATIVO — Experiencia tipo App
      ═══════════════════════════════════════════════ */}
      <div className="md:hidden relative z-10 w-full pt-24 pb-16 px-4">

        {/* ── Live badge ── */}
        <div className="flex justify-center mb-5">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/20 bg-background-50/5 backdrop-blur-sm">
            <span className="relative flex h-2.5 w-2.5">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-accent-500"></span>
            </span>
            <span className="text-background-50/85 text-xs font-medium">La comunidad de radio más grande del mundo</span>
          </div>
        </div>

        {/* ── Player: elemento principal ── */}
        <div className="mb-6">
          <DigitalDial />
        </div>

        {/* ── Título ── */}
        <h1 className="text-2xl font-extrabold text-background-50 leading-tight text-center px-1 mb-3">
          La Red Social Más Grande para{' '}
          <span className="text-accent-400">Radios</span>,{' '}
          <span className="text-accent-400">Locutores</span>,{' '}
          <span className="text-accent-400">Programas</span> y{' '}
          <span className="text-accent-400">Oyentes</span>
        </h1>

        {/* ── Descripción ── */}
        <p className="text-sm text-background-50/70 text-center mb-6">
          Escucha, descubre, sigue y haz crecer tu comunidad desde un solo lugar.
        </p>

        {/* ── Stats — scroll horizontal ── */}
        <div className="mb-6 -mx-4 px-4">
          <div
            className="flex gap-3 overflow-x-auto scrollbar-hide pb-1 snap-x snap-mandatory"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {heroStats.map((stat) => (
              <div
                key={stat.label}
                className="flex items-center gap-2.5 px-3.5 py-3 rounded-xl bg-background-50/5 backdrop-blur-sm border border-background-50/10 shrink-0 snap-start min-w-[140px]"
              >
                <div className="w-6 h-6 flex items-center justify-center shrink-0 rounded-full bg-background-50/10">
                  <i className={`${stat.icon} text-accent-400 text-xs`}></i>
                </div>
                <div>
                  <div className="text-background-50 font-bold text-sm whitespace-nowrap">
                    {stat.value.toLocaleString()}{stat.suffix}
                  </div>
                  <div className="text-background-50/50 text-[10px] whitespace-nowrap">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* ── CTAs principales — botones grandes full-width ── */}
        <div className="flex flex-col gap-2.5 mb-6">
          <button
            onClick={() => navigate('/app')}
            className="w-full py-4 bg-accent-500 hover:bg-accent-600 active:bg-accent-700 text-background-50 font-bold rounded-xl transition-all duration-150 whitespace-nowrap cursor-pointer text-sm shadow-lg shadow-accent-500/30 flex items-center justify-center gap-2 active:scale-[0.98]"
          >
            <i className="ri-headphone-line text-lg"></i>
            Escuchar Ahora
          </button>
          <button
            onClick={() => navigate('/register-radio')}
            className="w-full py-4 bg-primary-500 hover:bg-primary-600 active:bg-primary-700 text-background-50 font-bold rounded-xl transition-all duration-150 whitespace-nowrap cursor-pointer text-sm shadow-lg shadow-primary-500/30 flex items-center justify-center gap-2 active:scale-[0.98]"
          >
            <i className="ri-add-circle-line text-lg"></i>
            Registrar Mi Radio
          </button>
          <button
            onClick={() => navigate('/radios')}
            className="w-full py-3.5 bg-background-50/10 hover:bg-background-50/15 active:bg-background-50/20 backdrop-blur-sm text-background-50 font-semibold rounded-xl border border-background-50/25 transition-all duration-150 whitespace-nowrap cursor-pointer text-sm flex items-center justify-center gap-2 active:scale-[0.98]"
          >
            <i className="ri-compass-3-line text-lg"></i>
            Explorar Radios
          </button>
        </div>

        {/* ── Community Pills — scroll horizontal ── */}
        <div className="-mx-4 px-4 mb-5">
          <div
            className="flex gap-2 overflow-x-auto scrollbar-hide pb-1"
            style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}
          >
            {communityPills.map((pill) => (
              <button
                key={pill.label}
                onClick={() => navigate(pill.href)}
                className="flex items-center gap-1.5 px-3.5 py-2.5 rounded-full bg-background-50/10 border border-background-50/20 text-background-50/90 text-xs font-semibold backdrop-blur-sm whitespace-nowrap shrink-0 transition-all duration-150 active:scale-95 cursor-pointer"
              >
                <span className={`w-5 h-5 rounded-full ${pill.color} flex items-center justify-center`}>
                  <i className={`${pill.icon} text-[10px]`}></i>
                </span>
                {pill.label}
              </button>
            ))}
          </div>
        </div>

        {/* ── Publicidad adaptada al ancho mobile ── */}
        {heroLeftAds.length > 0 && (
          <div className="mb-3">
            <a
              href={heroLeftAds[0].ctaUrl}
              className="flex items-center gap-3 px-4 py-3 rounded-xl bg-background-50/5 backdrop-blur-sm border border-background-50/10 active:bg-background-50/10 transition-colors cursor-pointer"
            >
              <div className="w-10 h-10 rounded-lg bg-background-50/10 flex items-center justify-center shrink-0">
                <img
                  src={heroLeftAds[0].imageUrl}
                  alt={heroLeftAds[0].title}
                  className="w-full h-full object-cover rounded-lg"
                  loading="lazy"
                />
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-background-50/80 text-xs font-semibold truncate">{heroLeftAds[0].title}</div>
                <div className="text-background-50/45 text-[10px] truncate mt-0.5">{heroLeftAds[0].description}</div>
              </div>
              <span className="text-background-50/30 text-[9px] font-medium uppercase shrink-0 tracking-wider">Ad</span>
            </a>
          </div>
        )}

        {/* ── Indicador de scroll ── */}
        <div className="flex justify-center pt-2">
          <a
            href="#explorar"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector('#explorar');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex flex-col items-center gap-1.5 text-background-50/40 hover:text-background-50/70 transition-colors cursor-pointer"
          >
            <span className="text-[10px] font-medium">Desliza para descubrir</span>
            <i className="ri-arrow-down-s-line text-sm animate-bounce"></i>
          </a>
        </div>
      </div>

      {/* ═══════════════════════════════════════════════
          DESKTOP — Layout completo preservado
      ═══════════════════════════════════════════════ */}
      <div className="hidden md:flex items-center min-h-screen relative z-10 w-full px-4 md:px-8 lg:px-12 py-24 md:py-28">
        <div className="flex items-start justify-between w-full">
          <div className="hidden lg:block w-[150px] xl:w-[180px] shrink-0 sticky top-28">
            <AdCard ads={heroLeftAds} />
          </div>

          <div className="flex-1 min-w-0">
            <div className="relative flex flex-col lg:flex-row items-center gap-10 lg:gap-16 w-full">

              <DownloadAppButton />

              {/* ── Columna izquierda: texto ── */}
              <div className="flex-1 w-full text-center lg:text-left lg:max-w-[580px]">
                <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-background-50/20 bg-background-50/5 backdrop-blur-sm mb-6">
                  <span className="relative flex h-2.5 w-2.5">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-accent-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-accent-500"></span>
                  </span>
                  <span className="text-background-50/85 text-xs font-medium">La comunidad de radio más grande del mundo</span>
                </div>

                <h1 className="text-4xl md:text-5xl lg:text-5xl xl:text-6xl font-extrabold text-background-50 leading-[1.08] tracking-tight">
                  La Red Social Más Grande para{' '}
                  <span className="text-accent-400">Radios</span>,{' '}
                  <span className="text-accent-400">Locutores</span>,{' '}
                  <span className="text-accent-400">Programas</span> y{' '}
                  <span className="text-accent-400">Oyentes</span>
                  <span className="text-accent-400">.</span>
                </h1>

                <p className="mt-5 text-base md:text-lg text-background-50/70 max-w-xl mx-auto lg:mx-0 leading-relaxed">
                  Escucha, descubre, sigue, comparte y haz crecer tu comunidad desde un solo lugar.
                </p>

                {/* ── 7 Community Pills ── */}
                <div className="mt-7 flex flex-wrap items-center justify-center lg:justify-start gap-2">
                  {communityPills.map((pill) => (
                    <button
                      key={pill.label}
                      onClick={() => navigate(pill.href)}
                      className="inline-flex items-center gap-1.5 px-3.5 py-2 rounded-full bg-background-50/10 border border-background-50/20 text-background-50/90 text-xs font-semibold backdrop-blur-sm whitespace-nowrap transition-all duration-200 hover:bg-background-50/20 hover:border-background-50/35 hover:scale-105 cursor-pointer"
                    >
                      <span className={`w-5 h-5 rounded-full ${pill.color} flex items-center justify-center`}>
                        <i className={`${pill.icon} text-[10px]`}></i>
                      </span>
                      {pill.label}
                    </button>
                  ))}
                </div>

                {/* ── Stats Row ── */}
                <div className="mt-6 grid grid-cols-3 gap-2 lg:gap-3 mx-auto lg:mx-0">
                  {heroStats.map((stat) => (
                    <div key={stat.label} className="flex flex-col items-center lg:items-start gap-1 px-3 py-2.5 rounded-xl bg-background-50/5 backdrop-blur-sm border border-background-50/10 hover:bg-background-50/10 transition-colors duration-200">
                      <div className="flex items-center gap-1.5">
                        <div className="w-4 h-4 flex items-center justify-center">
                          <i className={`${stat.icon} text-accent-400 text-xs`}></i>
                        </div>
                        <span className="text-background-50 font-bold text-sm md:text-base whitespace-nowrap">
                          {stat.value.toLocaleString()}{stat.suffix}
                        </span>
                      </div>
                      <span className="text-background-50/50 text-[10px] md:text-xs whitespace-nowrap leading-tight">{stat.label}</span>
                    </div>
                  ))}
                </div>
              </div>

              {/* ── Columna derecha: reproductor ── */}
              <div className="shrink-0 w-full max-w-[420px] lg:mr-12 flex justify-center">
                <DigitalDial />
              </div>
            </div>

            {/* ── 4 CTA Buttons — fila propia debajo de ambas columnas ── */}
            <div className="flex flex-col sm:flex-row items-center gap-3 justify-center w-full">
              <button
                onClick={() => navigate('/app')}
                className="w-full sm:w-auto px-6 py-3.5 bg-accent-500 hover:bg-accent-600 text-background-50 font-bold rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-sm shadow-lg shadow-accent-500/30 hover:shadow-accent-500/50 flex items-center gap-2"
              >
                <i className="ri-headphone-line text-base"></i>
                Escuchar Ahora
              </button>
              <button
                onClick={() => navigate('/register-radio')}
                className="w-full sm:w-auto px-6 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-50 font-bold rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-sm shadow-lg shadow-primary-500/30 hover:shadow-primary-500/50 flex items-center gap-2"
              >
                <i className="ri-add-circle-line text-base"></i>
                Registrar Mi Radio
              </button>
              <button
                onClick={() => navigate('/radios')}
                className="w-full sm:w-auto px-6 py-3.5 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 font-semibold rounded-xl border border-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm flex items-center gap-2"
              >
                <i className="ri-compass-3-line text-base"></i>
                Explorar Radios
              </button>
              <button
                onClick={() => navigate('/tv-app')}
                className="w-full sm:w-auto px-6 py-3.5 bg-background-50/10 hover:bg-background-50/20 backdrop-blur-sm text-background-50 font-semibold rounded-xl border border-background-50/25 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm flex items-center gap-2"
              >
                <i className="ri-tv-line text-base"></i>
                Ver RFW TV
              </button>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block">
          <a
            href="#explorar"
            onClick={(e) => {
              e.preventDefault();
              const el = document.querySelector('#explorar');
              if (el) el.scrollIntoView({ behavior: 'smooth' });
            }}
            className="flex flex-col items-center gap-2 text-background-50/50 hover:text-background-50/80 transition-colors cursor-pointer"
          >
            <span className="text-xs font-medium">Descubre todo lo que la comunidad tiene para vos</span>
            <i className="ri-arrow-down-line text-lg animate-bounce"></i>
          </a>
        </div>
      </div>
    </section>
  );
}